import React, { useContext, useEffect, useState} from 'react';
import logo from '../../assets/logo.webp';
import { Navbar, Nav, Container, Dropdown } from 'react-bootstrap';
import appStore from '../../assets/appstore.webp';
import googlePlay from '../../assets/googleplay.webp';
import { useLocation, useNavigate } from 'react-router-dom';
import AuthContext from '../../context/AuthContext';

const Header = () => {

  const { isLoggedIn, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992); // Bootstrap lg breakpoint is 992px
    };

    handleResize(); // initial check
    window.addEventListener('resize', handleResize); // listen on resize

    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <Navbar bg="white" variant="light" expand="lg" sticky="top">
      <Container>
        <Navbar.Brand href="/home">
          <img className='logo'
            src={logo}
            alt="Breakdown Inc"
          // Adjust size as needed
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ml-auto cust-nav align-items-center">
            <Nav.Link href="/home" className={location.pathname === '/home' ? 'active' : ''}>Home</Nav.Link>
            <Nav.Link href="/plans" className={location.pathname === '/plans' ? 'active' : ''}>plans</Nav.Link>
            {/* <Nav.Link href="/about" className={location.pathname === '/about' ? 'active' : ''}>About</Nav.Link> */}
            <Nav.Link href="/blogs" className={location.pathname === '/blogs' ? 'active' : ''}>Blog</Nav.Link>
            <Nav.Link href="/contact" className={location.pathname === '/contact' ? 'active' : ''}>Contact</Nav.Link>
            {!isLoggedIn() ? (
              <>
                <Nav.Link href="/login" className={location.pathname === '/login' ? 'active' : ''}>Login</Nav.Link>
                <Nav.Link href="/signup" className={location.pathname === '/signup' ? 'active' : ''}>Sign Up</Nav.Link>
              </>
            ) : isMobile ? (
              <>
                <Nav.Link href="/customer-profile">Profile</Nav.Link>
                <Nav.Link href="/listings">Listings</Nav.Link>
                <Nav.Link href="/leads">Leads</Nav.Link>
                <Nav.Link onClick={handleLogout} className="logout-item">Logout</Nav.Link>
              </>
            ) : (
              <Dropdown className="m-0 dash_menu">
                <Dropdown.Toggle variant="link" className="text-dark border-0 d-flex align-items-center" id="dropdown-user">
                  <i className="fa fa-user"/>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item className= "m-0" onClick={() => navigate('/customer-profile')}>Profile</Dropdown.Item>
                  <Dropdown.Item className= "m-0" onClick={() => navigate('/listings')}>Listings</Dropdown.Item>
                  <Dropdown.Item className= "m-0" onClick={() => navigate('/leads')}>Leads</Dropdown.Item>
                  <Dropdown.Divider className='my-1' />
                  <Dropdown.Item className= "m-0 text-danger" onClick={handleLogout}>Logout</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            )}

            <Nav.Link className='img_btn' target='blank' href="https://apps.apple.com/us/app/breakdown-inc/id1459289134"><img src={appStore} className='img-fluid' alt='App Store' loading="lazy"/></Nav.Link>
            <Nav.Link className='img_btn' target='blank' href="https://play.google.com/store/apps/details?id=com.crinoid.breakdown&pli=1"><img src={googlePlay} className='img-fluid' alt='Play Store' loading="lazy"/></Nav.Link>
            {/* <Nav.Link className='app_btn' href="/app"><i className="fa fa-mobile-alt" title="mobile"></i> &nbsp;Download App</Nav.Link> */}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
